import React from 'react';
import styled, { keyframes } from 'styled-components/macro';

const rota = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const sweep = keyframes`
  0% {
    -webkit-clip-path: polygon(0% 0%, 0% 0%, 0% 0%, 50% 50%, 0% 0%, 0% 0%, 0% 0%);
    clip-path: polygon(0% 0%, 0% 0%, 0% 0%, 50% 50%, 0% 0%, 0% 0%, 0% 0%);
  }
  50% {
    -webkit-clip-path: polygon(0% 0%, 0% 100%, 0% 100%, 50% 50%, 100% 0%, 100% 0%, 0% 0%);
    clip-path: polygon(0% 0%, 0% 100%, 0% 100%, 50% 50%, 100% 0%, 100% 0%, 0% 0%);
  }
  100% {
    -webkit-clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 50% 50%, 100% 100%, 100% 0%, 0% 0%);
    clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 50% 50%, 100% 100%, 100% 0%, 0% 0%);
  }
`;

const Wrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 10px solid #333;
  box-sizing: border-box;
  -webkit-animation: ${sweep} 1s linear alternate infinite, ${rota} 0.8s linear infinite;
  animation: ${sweep} 1s linear alternate infinite, ${rota} 0.8s linear infinite;
}`;

interface IProps {
  size?: number;
  spinnerColor?: string;
  spinnerWidth?: number;
  visible?: boolean;
  [key: string]: any;
}

const Spinner: React.FC<IProps> = ({
  visible = true,
  spinnerColor = '#333333',
  spinnerWidth = 5,
  size = 40,
  ...rest
}) => !visible
    ? null
    : (
      <Wrapper
        {...rest}
        style={{
          width: size,
          height: size,
          borderColor: spinnerColor,
          borderWidth: spinnerWidth
        }}
      />
    );

export default Spinner;
